import React, { useContext, useEffect, useState } from 'react'
import IUser from '@interfaces/IUser'
import * as $Revisor from '@services/Revisor'
import { Link, useNavigate, useParams } from 'react-router-dom'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import AuthContext from '@contexts/Auth'

const RevisorsEdit: React.FC<any> = () => {
  const { year } = useContext(AuthContext)

  const { id: revisorId }: any = useParams()

  const [ revisor, setRevisor ] = useState<IUser>({} as IUser)
  const [ isLoading, setIsLoading ] = useState<boolean>(true)

  const SweetAlert = withReactContent(Swal)
  const navigate = useNavigate()

  useEffect(() => {
    $Revisor.find(revisorId).then(({ data: revisor }) => {
      if (revisor.year !== year) {
        navigate('/corretores')
        return
      }

      setRevisor(revisor)
    }).finally(() => setIsLoading(false))
  }, [navigate, revisorId, year])

  const handleUserChange = (e: any) => {
    const { name, value } = e.target

    setRevisor({
      ...revisor,
      [name]: value,
    })
  }

  const update = () => {
    setIsLoading(true)

    SweetAlert.showLoading()

    $Revisor.update(revisor.id as number, {
      name: revisor.name,
      email: revisor.email,
      nickname: revisor?.nickname,
      password: revisor.password,
      passwordConfirmation: revisor.passwordConfirmation,
    } as IUser).then(() => {
      SweetAlert.fire({
        title: 'Sucesso!',
        text: 'Corretor atualizado com sucesso!',
        icon: 'success'
      })
    }).catch(e => {
      SweetAlert.fire({
        title: 'Erro!',
        text: e.response?.data?.message ?? 'Erro ao atualizar o corretor!',
        icon: 'error'
      })
    }).finally(() => {
      setIsLoading(false)
      SweetAlert.hideLoading()
    })
  }

  return (
    <>
      <div className="d-flex justify-content-end mb-3">
        <Link to="/corretores" className="btn btn-outline-primary me-2">Voltar</Link>
        <button className="btn btn-primary" onClick={update} disabled={isLoading}>Atualizar</button>
      </div>

      <div className="card mb-3">
        <div className="card-header">
          Editar corretor ({revisor?.nickname})
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-md-4">
              <div className="form-group mb-3">
                <label htmlFor="nickname">Apelido</label>
                <input type="text" className="form-control" name="nickname" id="nickname" placeholder="Apelido" defaultValue={revisor?.nickname} onChange={handleUserChange} />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group mb-3">
                <label htmlFor="name">Nome</label>
                <input type="text" className="form-control" name="name" id="name" placeholder="Nome" defaultValue={revisor?.name} onChange={handleUserChange} />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group mb-3">
                <label htmlFor="email">E-mail</label>
                <input type="email" className="form-control" name="email" id="email" placeholder="E-mail" defaultValue={revisor?.email} onChange={handleUserChange} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-header">
          Alteração de senha
        </div>

        <div className="card-body pb-0">
          <div className="row">
            <div className="col-12 col-md-6 mb-3">
              <div className="form-group">
                <label htmlFor="password">Nova senha (mínimo 6 caracteres)</label>
                <input type="password" name="password" className="form-control" id="password" placeholder="Nova senha" onChange={handleUserChange} autoComplete="new-password" />
              </div>
            </div>

            <div className="col-12 col-md-6 mb-3">
              <div className="form-group">
                <label htmlFor="passwordConfirmation">Confirmação da senha</label>
                <input type="password" name="passwordConfirmation" className="form-control" id="passwordConfirmation" placeholder="Confirmação da senha" onChange={handleUserChange} autoComplete="new-password" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default RevisorsEdit
